import { SITE_PAGES } from 'Config';
import PropTypes from 'prop-types';
import AdminLanding from '../AdminLanding';
import VendorDetails from './VendorDetails';

const VendorDetailPage = ({ params }) => {
  let breadcrumbs = params?.id && [
    SITE_PAGES.MANAGE_VENDORS,
    {
      icon: 'shop',
      text: params.id,
    },
  ];

  return (
    <AdminLanding title='Manage Vendor' breadcrumbs={breadcrumbs}>
      <VendorDetails editable params={params} />
    </AdminLanding>
  );
};

VendorDetailPage.propTypes = {
  params: PropTypes.shape({ id: PropTypes.string }),
};

export default VendorDetailPage;
